import { useAccount, useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';

import { GetBaseCompanyInfoViaCompanyId } from '../../../http/Company/company';
import queryKeys from './queryKeys';

const useBaseCompanyInfo = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const companyId = Number(account?.idTokenClaims?.extension_companyid);

  const query = useQuery({
    queryKey: [queryKeys.baseCompanyInfo, account?.idTokenClaims?.extension_companyid],
    queryFn: () =>
      GetBaseCompanyInfoViaCompanyId(
        account?.idTokenClaims?.extension_companyid as string,
        false
      ),
    staleTime: 600000,
    enabled: !!companyId
  });

  return query;
};

export default useBaseCompanyInfo;
